const ce = (tag = 'div', classNames, attributes) => {
    const el = document.createElement(tag);
    if (classNames) {
        if (typeof classNames === 'string') {
            el.classList.add(classNames);
        }
        if (Array.isArray(classNames)) {
            classNames.map((className) => {
                el.classList.add(className);
            })
        }
    }
    if (attributes) {
        Object.keys(attributes).map((key) => {
            el.setAttribute(key, attributes[key]);
        })
    }
    return el;
}

// попап поиска
const showHeaderSearch = () => {
    const searchPopup = document.getElementById('headerSearch');
    if (searchPopup) {
        searchPopup.classList.add('m-header-search_show');
        document.addEventListener('click', (e) => {
            if (!searchPopup.contains(e.target)) {
                hideHeaderSearch();
            }
        });
        return true;
    }
    return false;
};

const hideHeaderSearch = () => {
    const searchPopup = document.getElementById('headerSearch');
    if (searchPopup) {
        searchPopup.classList.remove('m-header-search_show');
        document.body.removeEventListener('click', hideHeaderSearch);
        return true;
    }
    return false;
};

window.addEventListener('load', () => {
    const headerSearchButton = document.getElementById('headerSearchButton');
    if (headerSearchButton) {
        headerSearchButton.addEventListener('click', showHeaderSearch);
        const headerSearchPopupClose = document.getElementById('headerSearchPopupClose');
        headerSearchPopupClose.addEventListener('click', hideHeaderSearch);
    }
});

// swiper
window.addEventListener('load', () => {
    // console.log(document.querySelectorAll('.project-item').length)
    if (document.querySelectorAll('.project-item').length > 0) {
        bindProjectPopups()
    }
    const projectsNode = document.querySelector('.project-list .swiper');
    // if (projectsNode) {
    //     new Swiper(projectsNode, {
    //         slidesPerView: 'auto',
    //         spaceBetween: 30,
    //         //allowTouchMove: false,
    //         slidesPerGroupSkip: 1,
    //         navigation: {
    //             nextEl: '.swiper-button-next_projects',
    //             prevEl: '.swiper-button-prev_projects',
    //         },
    //         breakpoints: {
    //             /*1150: {
    //                 slidesPerView: 'auto',
    //             },*/
    //             /*900: {
    //                 slidesPerView: 1,
    //             },
    //             630: {
    //                 slidesPerView: 2,
    //             },
    //             320: {
    //               slidesPerView: 1,
    //             },*/
    //         },
    //         on: {
    //             beforeInit: (swiper) => {
    //                 const countSlides = swiper.slides.length;
    //
    //                 swiper.params.loop = true;
    //                 swiper.params.loopedSlides = countSlides;
    //
    //                 swiper.update();
    //                 let mobileLayout = false;
    //                 window.addEventListener('resize', () => {
    //                     if (!mobileLayout && window.matchMedia('(max-width: 1150px)').matches) {
    //                         for (const slide of swiper.slides) {
    //                             slide.style.width = '100%';
    //                         }
    //                         swiper.updateSlides();
    //                         swiper.slideReset();
    //                         mobileLayout = true;
    //                     }
    //                 });
    //             },
    //             afterInit: () => {
    //                 bindProjectPopups();
    //             },
    //             activeIndexChange: (swiper) => {
    //                 if (window.matchMedia('(min-width: 1150px)').matches) {
    //                     for (const slide of swiper.slides) {
    //                         slide.style.width = 'calc(25% - 15px)';
    //                     }
    //                     swiper.slides[swiper.activeIndex].style.width = 'calc(50% - 30px)';
    //                 } else if (window.matchMedia('(min-width: 900px)').matches) {
    //                     for (const slide of swiper.slides) {
    //                         slide.style.width = '100%';
    //                     }
    //                 } else if (window.matchMedia('(min-width: 630px)').matches) {
    //                     for (const slide of swiper.slides) {
    //                         slide.style.width = 'calc(50% - 15px)';
    //                     }
    //                 } else {
    //                     for (const slide of swiper.slides) {
    //                         slide.style.width = '100%';
    //                     }
    //                 }
    //                 swiper.updateSlides();
    //                 swiper.slideReset();
    //             }
    //         },
    //     });
    // }
    const videosNode = document.querySelector('.videos-list__slider .swiper');
    if (videosNode) {
        new Swiper(videosNode, {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination_videos',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next_videos',
                prevEl: '.swiper-button-prev_videos',
            },
            breakpoints: {
                1150: {
                    slidesPerView: 4,
                },
                850: {
                    slidesPerView: 3,
                },
                550: {
                    slidesPerView: 2,
                },
                260: {
                    slidesPerView: 1,
                },
            }
        });
    }

    const advantagesNode = document.querySelector('.about-docs__slider .swiper');
    if (advantagesNode) {
        new Swiper(advantagesNode, {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination_about-docs',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next_about-docs',
                prevEl: '.swiper-button-prev_about-docs',
            },
            breakpoints: {
                1150: {
                    slidesPerView: 4,
                },
                850: {
                    slidesPerView: 3,
                },
                550: {
                    slidesPerView: 2,
                },
                260: {
                    slidesPerView: 1,
                },
            }
        });
    }
});

// modals
import {showModal, watchScrollY} from "./modal";

watchScrollY();

const createNode = (className = '', tagName = 'div') => {
    const el = document.createElement(tagName);
    el.className = className;

    return el;
}

const createSwiperHTML = (images, className = 'm-modal__swiper') => {
    const swiperNode = createNode(className);
    const swiper = createNode('swiper');
    const swiperWrapper = createNode('swiper-wrapper');

    images.map((el) => {
        const slide = createNode('swiper-slide');
        const img = createNode('', 'img');
        img.setAttribute('src', el);
        slide.append(img);
        swiperWrapper.append(slide);
    })
    swiper.append(swiperWrapper);
    swiperNode.append(swiper);
    swiper.append(createNode('swiper-button-next'));
    swiper.append(createNode('swiper-button-prev'));

    return swiperNode;
};

const fillProjectPopupData = (node) => {
    const root = node.closest('.project-item');
    const popupTitle = document.querySelector('#modal-projects .m-modal__title');
    const popupContent = document.querySelector('#modal-projects .m-modal__content');

    popupTitle.innerText = root.querySelector('.project-item__title').innerText;
    popupContent.innerHTML = '';

    if (root.getAttribute('data-images')) {
        const imgArr = JSON.parse(root.getAttribute('data-images'));
        const swiperHTML = createSwiperHTML(imgArr);
        popupContent.append(swiperHTML);
    } else {
        const img = document.createElement('img');
        img.src = root.querySelector('.project-item__img img').src;
        popupContent.append(img);
    }
    popupContent.innerHTML += root.querySelector('.project-item__popup-text').innerHTML;
};
const bindProjectPopups = () => {
    [...document.querySelectorAll('.js-project-popup')].map(link => {
        link.addEventListener('click', (e) => {

            e.preventDefault();
            const target = e.target.href ? e.target : e.target.closest('a');
            showModal(target, () => {
                fillProjectPopupData(target);
            }, () => {
                new Swiper(document.querySelector('.m-modal__swiper .swiper'), {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            });
        });
    });
};

const fillPopupVideo = (data = {type: '', value: ''}) => {
    if (!data.type) {
        return false;
    }
    let htmlString = '';
    switch (data.type) {
        case 'youtube': {
            htmlString = `
    <iframe src="https://www.youtube-nocookie.com/embed/${data.value}?controls=0"
     title="YouTube video player"
      frameborder="0"
       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            break;
        }
        case 'embeded': {
            htmlString = `<video controls loop autoplay poster="${data.poster}">
<source src="${data.value}" type="video/mp4">
</video>`;
            break;
        }
        default: {
            return false;
        }
    }
    const videoContainer = document.getElementById('video169');
    videoContainer.innerHTML = htmlString;
};

window.addEventListener('load', () => {
    const videoPopupLinks = [...document.querySelectorAll('.js-youtube-link, .js-video-link')];
    const targetPopup = document.getElementById('modal-videos');
    if (videoPopupLinks.length > 1) {
        targetPopup.classList.add('m-modal_controls');
    }

    const calculateIndex = (method, currentIndex, length) => {
        const current = Number(currentIndex);
        switch (method) {
            case 'inc': {
                if (current === length - 1) {
                    return 0;
                }
                return current + 1;
            }
            case 'dec': {
                if (current === 0) {
                    return length - 1;
                }
                return current - 1;
            }
            default:
                return current;
        }
    };
    const getData = (node) => {
        if (node.classList.contains('js-youtube-link')) {
            return {
                type: 'youtube',
                value: node.getAttribute('data-code'),
            };
        }
        if (node.classList.contains('js-video-link')) {
            return {
                type: 'embeded',
                value: node.getAttribute('href'),
                poster: node.getAttribute('data-poster'),
            };
        }
        return '';
    }

    const controls = targetPopup.querySelectorAll('.m-modal__control');
    if (controls.length) {
        for (const control of controls) {
            control.addEventListener('click', (e) => {
                e.preventDefault();
                const method = control.getAttribute('data-action');
                const currentIndex = targetPopup.getAttribute('data-current-index');
                const newIndex = calculateIndex(method, currentIndex, videoPopupLinks.length);
                fillPopupVideo(getData(videoPopupLinks[newIndex]));
                targetPopup.setAttribute('data-current-index', String(newIndex));
            });
        }
    }

    videoPopupLinks.map((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const youtubeNode = e.target.classList.contains('js-youtube-link') ? e.target : e.target.closest('.js-youtube-link');
            const videoNode = e.target.classList.contains('js-video-link') ? e.target : e.target.closest('.js-video-link');
            const target = youtubeNode || videoNode;
            showModal('#modal-videos', () => {
                fillPopupVideo(getData(target));
                targetPopup.setAttribute('data-current-index', String(index));
            });
        });
    });
});

// burger
window.addEventListener('load', () => {

    let mobileMenu = document.querySelector('#m-headerMobile')
    const showMobileMenu = () => {

        mobileMenu.classList.add('is-open');
    };

    const hideMobileMenu = () => {
        mobileMenu.classList.remove('is-open');
    };

    const burger = document.getElementById('headerBurger');
    if (burger) {
        burger.addEventListener('click', (e) => {
            e.preventDefault();
            if (!burger.classList.contains('m-header__burger_active')) {
                burger.classList.add('m-header__burger_active');
                showMobileMenu();
            } else {
                burger.classList.remove('m-header__burger_active');
                hideMobileMenu();

            }
        });

        // document.getElementById('headerMobileClose').addEventListener('click', (e) => {
        //     e.preventDefault();
        //     hideMobileMenu();
        // });
    }
});

// front-video
const fadeIn = (el, display) => {
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        let val = parseFloat(el.style.opacity);
        if (!((val += .025) > 1)) {
            el.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
};

const fadeOut = (el, cb) => {
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= .025) < 0) {
            el.style.display = "none";
            if (typeof cb === 'function') {
                cb();
            }
        } else {
            requestAnimationFrame(fade);
        }
    })();
};


// set min height

const setMinHeight = (arrNodes) => {
    const mobile = window.matchMedia('(max-width: 650px)').matches;
    const height = arrNodes.reduce((acc, el) => {
        el.style.minHeight = 'unset';
        const elHeight = el.offsetHeight;
        if (elHeight > acc) {
            return elHeight;
        }
        return acc;
    }, 0);
    for (const el of arrNodes) {
        if (mobile) {
            el.style.minHeight = 'unset';
            return false;
        }
        el.style.minHeight = height + 'px';
    }
};

const startHeightAbjust = (groups = [[]]) => {
    for (const group of groups) {
        setMinHeight(group);
    }
};

window.addEventListener('load', () => {
    const nodes = [...document.querySelectorAll('.js-set-min-height')];

    const arrGroups = nodes.reduce((acc, el, index) => {
        const dataAttributeValue = el.getAttribute('data-minheight');
        const dataIndex = acc.selectors[dataAttributeValue];
        if (dataIndex !== undefined) {
            const newElements = acc.elements.slice();
            newElements[dataIndex] = [...newElements[dataIndex], el];
            return {
                ...acc,
                elements: newElements,
            }
        }
        return {
            selectors: {
                ...acc.selectors,
                [dataAttributeValue]: acc.elements.length,
            },
            elements: [...acc.elements, [el]],
        };
    }, {
        selectors: {},
        elements: [],
    }).elements;

    startHeightAbjust(arrGroups);

    window.addEventListener('resize', () => {
        startHeightAbjust(arrGroups);
    });
});

// detail

window.addEventListener('load', () => {
    const detailSliderNode = document.getElementById('detailSlider');
    if (detailSliderNode) {
        const thumbsSlider = new Swiper('#detailSliderThumbs .swiper', {
            navigation: {
                nextEl: '.js-detail-next',
                prevEl: '.js-detail-prev',
            },

            spaceBetween: 21,
            slidesPerView: 4,
            breakpoints: {
                320: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },

                900: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1100: {
                    spaceBetween: 21,
                    slidesPerView: 4
                }
            }
        })
        const isDynamicBullets = window.innerWidth < 900 ? true : false;
        const detailSwiper = new Swiper(detailSliderNode.querySelector('.swiper'), {
            thumbs: {
                swiper: thumbsSlider,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: isDynamicBullets
            }

        });
    }
});


class MTabs {
    constructor(node, settings = {cb: {}}) {
        this.node = typeof node === 'string' ? document.querySelector(node) : node;
        if (!this.node) {
            console.warn('Selector error');
            return false;
        }
        this.buttons = this.node.querySelectorAll('.m-tabs__head-item');
        this.contents = this.node.querySelectorAll('.m-tabs__content-item');
        if (!this.buttons.length || !this.contents) {
            console.warn('HTML error');
            return false;
        }
        this.cb = settings['cb'];
        this.initialTabIndex = settings.initialTabIndex ? settings.initialTabIndex - 1 : 0;

        this.init();

        this.checkHash();
    }

    init() {
        if (typeof this.cb['beforeInit'] === 'function') {
            this.cb['beforeInit']();
        }

        this.checkHrefs();
        const hash = this.checkHash();
        if (hash) {
            this.changeTab(hash);
        } else {
            this.changeTab(this.initialTabIndex);
        }
        this.bindClick();

        if (typeof this.cb['afterInit'] === 'function') {
            this.cb['afterInit']();
        }
    }

    checkHrefs() {
        const id = `tabs${(~~(Math.random() * 1e8)).toString(8)}`;
        [...this.buttons].map((button, index) => {
            if (!button.getAttribute('href')) {
                button.setAttribute('href', `#${id}${index}`);
                this.contents[index].setAttribute('id', id);
            }
        })
    }

    checkHash() {
        const hash = window.location.hash;
        if (!hash) {
            return false;
        }
        const hashIndex = [...this.contents].indexOf(this.node.querySelector(`${hash}`));
        if (hashIndex > -1) {
            return hashIndex;
        }
        return null;
    }

    changeTab(targetIndex) {
        if (typeof this.cb['beforeChange'] === 'function') {
            this.cb['beforeChange']();
        }

        [...this.buttons].map((el, index) => {
            if (index === targetIndex) {
                el.classList.add('m-tabs__head-item_active');
                this.contents[index].classList.remove('m-tabs__content-item_hidden');
                return true;
            }
            el.classList.remove('m-tabs__head-item_active');
            this.contents[index].classList.add('m-tabs__content-item_hidden');
            return false;
        });

        if (typeof this.cb['afterChange'] === 'function') {
            this.cb['afterChange']();
        }
    }

    bindClick() {
        [...this.buttons].map((button, index) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.changeTab(index);
            })
        })
    }
}

//tabs
window.addEventListener('load', function () {
    const jsTabs = document.querySelectorAll('.js-m-tabs');
    if (jsTabs.length) {
        for (let tabs of jsTabs) {
            new MTabs(tabs);
        }
    }
    const projectSwiperNodes = document.querySelectorAll('.m-projects__slider .swiper');
    if (projectSwiperNodes.length) {
        for (let swiperNode of projectSwiperNodes) {
            new Swiper(swiperNode, {
                autoHeight: true,
                pagination: {
                    clickable: true,
                },
                on: {
                    beforeInit: function (swiper) {
                        const parentNode = swiper.el.parentNode;
                        swiper.params.pagination.el = parentNode.querySelector('.swiper-pagination');
                        swiper.params.navigation.prevEl = parentNode.querySelector('.swiper-button-prev');
                        swiper.params.navigation.nextEl = parentNode.querySelector('.swiper-button-next');
                    }
                }
            });
        }
    }
})

// PhoneMask init
const bindPhoneMask = () => {
    for (let input of document.querySelectorAll('input[name="PHONE"],.js-tel')) {
        $(input).inputmask('remove');
        new PhoneMask(input);
    }

    let inited = false;
    const watcher = setInterval(() => {
        const phoneInputs = document.querySelectorAll('input[name="PHONE"],.js-tel');
        if (phoneInputs.length) {
            for (let input of phoneInputs) {
                if (input.classList.contains('js-ph-inited')) {
                    continue;
                }
                new PhoneMask(input);
                input.classList.add('js-ph-inited');
            }
        }

    }, 250);
};

bindPhoneMask();


(function ($) {
    $(function () {
        // breadcrumb control - переключение хлебных крошек
        function togglebreadcrumbInside(btn) {
            if (!btn.hasClass('open')) {
                btn.addClass('open').find('.breadcrumb__popup').slideDown(200);
            } else {
                btn.removeClass('open').find('.breadcrumb__popup').slideUp(200);
            }
        }

        // events breadcrumb
        $(document).on('click', '.js-breadcrumb .breadcrumb__item_points > a, .js-breadcrumb .breadcrumb__item_points .breadcrumb__close', function (e) {
            e.preventDefault();
            let currentElem = $(this).parents('.breadcrumb__item_points');
            togglebreadcrumbInside(currentElem);
        });
    });
})(jQuery);

// hide promos

const hidePromo = (promosWrapperNode) => {
    if (!promosWrapperNode) {
        return false;
    }

    const promos = [...promosWrapperNode.querySelectorAll('.productStock')];

    if (promos.length < 3) {
        return false;
    }

    const hideElements = () => {
        promos.map((el, index) => {
            if (index > 1) {
                el.style.display = "none";
            }
        })
        promosWrapperNode.classList.add('m-catalog-item__promo_hide');
    }

    const showElements = () => {
        promos.map((el) => {
            el.style.display = "block";
        })
        promosWrapperNode.classList.remove('m-catalog-item__promo_hide');
    }

    const addButton = () => {
        const moreBtn = document.createElement('button');
        moreBtn.setAttribute('type', 'button');
        moreBtn.classList.add('m-catalog-item__promo-more');

        moreBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (promosWrapperNode.classList.contains('m-catalog-item__promo_hide')) {
                showElements();
                return false;
            }
            hideElements();
        })

        promosWrapperNode.append(moreBtn);
    }

    hideElements();
    addButton();
}

const initEngineeringProjects = () => {
    const selector = '.js-engineering-projects';

    if (!document.querySelector(selector)) return false;

    new Swiper(selector + ' .swiper', {
        loop: false,
        slidesPerView: 4,
        pagination: {
            el: selector + ' .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: selector + ' .swiper-button-next',
            prevEl: selector + ' .swiper-button-prev',
        },
        breakpoints: {
            1150: {
                slidesPerView: 4,
            },
            850: {
                slidesPerView: 3,
            },
            550: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });
};

const initVideoBannerOnDesktop = () => {
    const videoBanner = document.querySelector('.js-video-banner');
    if (videoBanner && videoBanner.paused && window.innerWidth >= 800) videoBanner.play();
}

const initPreviewVideos = () => {
    const elements = document.querySelectorAll('.js-item-video-preview');

    if (!elements[0] || window.innerWidth < 800) return false;

    elements.forEach(element => {
        const videoElement = element.querySelector('video');

        if (videoElement) {
            element.addEventListener('mouseenter', () => {
                if (videoElement.paused) videoElement.play();
            });

            element.addEventListener('mouseleave', () => {
                if (!videoElement.paused) videoElement.pause();
            });
        }
    });
}

const initNewsTabs = () => {
    const blocks = document.querySelectorAll('.js-news-tabs');

    if (!blocks[0]) return false;

    blocks.forEach(block => init(block));

    function init(block) {
        const buttons = block.querySelectorAll('button[data-id]');

        if (!buttons[0]) return false;

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                if (!button.classList.contains('active')) {
                    open(block, button);
                }
            });
        });

        open(block, buttons[0]);
    }

    function open(block, button) {
        const id = button.getAttribute('data-id');
        const items = block.querySelectorAll('[data-id="' + id + '"]');

        if (!items[0]) return false;

        closeAll(block);

        items.forEach(item => item.classList.add('active'));
    };

    function closeAll(block) {
        const items = block.querySelectorAll('[data-id].active');

        if (!items[0]) return false;

        items.forEach(item => item.classList.remove('active'));
    };
};

window.addEventListener('load', () => {
    initEngineeringProjects();
    initVideoBannerOnDesktop();
    initPreviewVideos();
    initNewsTabs();
    for (const promosWrapper of document.querySelectorAll('.m-catalog-item__promo')) {
        hidePromo(promosWrapper);
    }
})

window.addEventListener('load', () => {
    const targetButtons = document.querySelectorAll('.js-targen-button');
    const videoSection = document.querySelector('.js-representation-video');
    if (targetButtons.length > 0) {
        targetButtons.forEach(function (targetButton) {
            targetButton.addEventListener('click', function () {
                targetButtons.forEach((button) => {
                    button.closest('.representation__section').classList.add('representation__section_hidden')
                })


                targetButton.closest('.representation__section').classList.toggle('representation__section_hidden')
            })
        })
    }

    if (videoSection) {
        $('.js-representation-video').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
    }


    const sliderWrapper = document.querySelector('.project-list__wrapper');

    function sliderInit(node) {
        if (!node) {
            return false;
        }
        const sliderContainer = node.querySelector('.project-list');
        const sliderInnerContainer = node.querySelector('.project-list__item');
        const sliderItems = node.querySelectorAll('.project-list__item-wrapper');
        sliderContainer.classList.add('swiper');
        sliderInnerContainer.classList.add('swiper-wrapper');
        sliderItems.forEach((el) => {
            el.classList.add('swiper-slide')
        })
        new Swiper(sliderContainer, {
            spaceBetween: 10,
            pagination: {
                el: '.project-list_pagination'
            }
        })
    }

    function sliderDie(node) {
        if (!node) {
            return false;
        }
        const sliderContainer = node.querySelector('.project-list');
        const sliderInnerContainer = node.querySelector('.project-list__item');
        const sliderItems = node.querySelectorAll('.project-list__item-wrapper');
        sliderContainer.classList.remove('swiper');
        sliderContainer.removeAttribute('style');
        sliderInnerContainer.classList.remove('swiper-wrapper');
        sliderInnerContainer.removeAttribute('style');
        sliderItems.forEach((el) => {
            el.classList.remove('swiper-slide')
            el.removeAttribute('style');
        })
        if (node.querySelector('.swiper-slide-active') && node.querySelector('.swiper-slide-next')) {
            node.querySelector('.swiper-slide-active').classList.remove('swiper-slide-active');
            node.querySelector('.swiper-slide-next').classList.remove('swiper-slide-next');
        }


    }


    let windowWidthLoaded = window.innerWidth;
    if (windowWidthLoaded <= 740) {
        sliderInit(sliderWrapper)
    }
    let windowWidthChanged;
    window.addEventListener('resize', (function () {
        windowWidthChanged = window.innerWidth;
        if (windowWidthChanged <= 740 && sliderWrapper) {
            sliderInit(sliderWrapper)
        } else if (sliderWrapper) {
            sliderDie(sliderWrapper)
        }
        // console.log(windowWidthLoaded)
        // console.log(windowWidthChanged)
    }))

})

window.addEventListener('load', () => {
    for (const input of document.querySelectorAll('input')) {
        input.addEventListener('focus', () => {
            document.body.classList.add('body_input-focus');
        })
        input.addEventListener('blur', () => {
            document.body.classList.remove('body_input-focus');
        })
    }
})

// front slider
const bindFrontSlider = (node) => {
    if (!node) {
        return false;
    }

    const adaptiveVideoSource = (node) => {
        if (!node) {
            return false;
        }

        const largePath = node.getAttribute('data-source-large');
        const mediumPath = node.getAttribute('data-source-medium');
        const smallPath = node.getAttribute('data-source-small');

        if (!mediumPath || !smallPath || !largePath) {
            return false;
        }

        const changeSrc = () => {

            const source = node.querySelector('source')

            if (window.matchMedia('(max-width: 1320px) and (min-width: 601px)').matches) {
                console.log('medium')
                if (source && source.getAttribute('src') === mediumPath) {
                    return false;
                }
                node.pause();
                node.innerHTML = '<source src="' + mediumPath + '" type="video/mp4">';
                node.load();
                node.play();
            }
            if (window.matchMedia('(max-width: 600px)').matches) {
                if (source && source.getAttribute('src') === smallPath) {
                    return false;
                }
                console.log('small')
                node.pause();
                node.innerHTML = '<source src="' + smallPath + '" type="video/mp4">';
                node.load();
                node.play();
            }
            if (window.matchMedia('(min-width: 1271px)').matches) {
                console.log('large')
                if (source && source.getAttribute('src') === largePath) {
                    return false;
                }
                node.pause();
                node.innerHTML = '<source src="' + largePath + '" type="video/mp4">';
                node.load();
                node.play();
            }
        }

        changeSrc();
        window.addEventListener('resize', changeSrc);
    }

    return new Swiper(node, {
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        on: {
            init: (swiper) => {
                if (swiper.el && swiper.el.querySelector('.m-front-slider__item-video video')) {
                    const media = swiper.el.querySelector('.m-front-slider__item-video video');
                    media.addEventListener('ended', () => {
                        swiper.slideNext();
                    })

                    adaptiveVideoSource(media);
                }
            },
            slideChangeTransitionEnd: (swiper) => {
                if (swiper.slides[swiper.activeIndex].classList.contains('m-front-slider__item-video')) {
                    const media = swiper.el.querySelector('.m-front-slider__item-video video');
                    if (media.paused || media.ended) {
                        media.play();
                    }
                    media.addEventListener('ended', () => {
                        swiper.slideNext();
                    })
                }
            }
        },
    })
}

// catalog list slider
const bindCatalogSlider = (node) => {
    if (!node) {
        return false;
    }

    return new Swiper(node, {
        slidesPerView: 'auto',
        spaceBetween: 25,
    })
}

const bindCatalogFilters = (filtersForm) => {

    const state = {}

    const bindFilterSlider = (node) => {
        if (!node) {
            return false;
        }

        const sliderNode = node.querySelector('.input-range__slider');

        noUiSlider.create(sliderNode, {
            range: {
                'min': Number(node.getAttribute('data-min')),
                'max': Number(node.getAttribute('data-max')),
            },
            start: [Number(node.getAttribute('data-min')), Number(node.getAttribute('data-max'))],
            connect: true,
            step: Number(node.getAttribute('data-step')) || 1,
            format: wNumb({
                decimals: 0,
                thousand: ' ',
            })
        })

        const [minInput, maxInput] = [...node.querySelectorAll('.input-range__inputs input')];

        sliderNode.noUiSlider.on('update', function (values, handle) {
            const value = values[handle];

            let inputVal = null;
            if (handle) {
                maxInput.value = value;
                inputVal = maxInput;
            } else {
                minInput.value = value;
                inputVal = minInput;
            }


            if (inputVal && inputVal.getAttribute('data-hide')) {
                let inputHide = document.getElementById(inputVal.getAttribute('data-hide'));
                if (inputHide) {
                    let rValue = value.replace(/\s/g, '');
                    if (rValue !== inputVal.getAttribute('data-max') && rValue !== inputVal.getAttribute('data-min')) {
                        inputHide.value = rValue;
                        if (typeof (smartFilter) != 'undefined' && smartFilter != null) {
                            smartFilter.keyup(inputHide);
                        }
                    }
                }
            }
        })

        sliderNode.noUiSlider.on('end', function (values, handle) {
            const value = values[handle];

            if (handle) {
                maxInput.value = value;
                updateState(node.getAttribute('data-key') + '_max', 'add', sliderNode,
                    node.querySelector('label:nth-child(2) span').innerText + ' ' + value + ' ' + node.getAttribute('data-measure'));

            } else {
                minInput.value = value;
                updateState(node.getAttribute('data-key') + '_min', 'add', sliderNode,
                    node.querySelector('label:nth-child(1) span').innerText + ' ' + value + ' ' + node.getAttribute('data-measure'));
            }
        })

        minInput.addEventListener('change', function () {
            sliderNode.noUiSlider.set([this.value, null]);
            updateState(node.getAttribute('data-key') + '_min', 'add', sliderNode,
                node.querySelector('label:nth-child(1) span').innerText + ' ' + this.value + ' ' + node.getAttribute('data-measure'));
        });

        maxInput.addEventListener('change', function () {
            sliderNode.noUiSlider.set([null, this.value]);
            updateState(node.getAttribute('data-key') + '_max', 'add', sliderNode,
                node.querySelector('label:nth-child(2) span').innerText + ' ' + this.value + ' ' + node.getAttribute('data-measure'));
        });

        minInput.addEventListener('keyup', (e) => {
            e.target.value = e.target.value.replace(/\D+$/g, '');
        })

        maxInput.addEventListener('keyup', (e) => {
            e.target.value = e.target.value.replace(/\D+$/g, '');
        })
    }

    for (const slider of filtersForm.querySelectorAll('.js-input-range')) {
        bindFilterSlider(slider);
    }

    const bindFilterScroll = (item) => {
        const title = item.querySelector('.m-catalog-filters__item-title');

        title.addEventListener('click', (e) => {
            e.preventDefault();
            item.classList.toggle('m-catalog-filters__item_opened');
        })
    }

    for (const filterItem of filtersForm.querySelectorAll('.m-catalog-filters__item')) {
        bindFilterScroll(filterItem);
    }

    for (const checkbox of filtersForm.querySelectorAll('input[type="checkbox"]')) {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                updateState(checkbox.getAttribute('id'), 'add', null, checkbox.nextElementSibling.querySelector('b').innerText);
            } else {
                updateState(checkbox.getAttribute('id'), 'delete');
            }
        })
    }

    const updateState = (key, action, slider, value) => {
        if (action === 'add') {
            state[key] = {
                value: value,
                slider: slider,
            }

            renderState(key);
            return true;
        }

        if (action === 'delete') {

            let InputFilter = null;

            if (state[key]['slider']) {
                state[key]['slider'].noUiSlider.set([
                    key.endsWith('_min') ? Number(state[key]['slider'].parentElement.dataset.min) : null,
                    key.endsWith('_max') ? Number(state[key]['slider'].parentElement.dataset.max) : null,
                ]);

                if (key.endsWith('_min')) {
                    InputFilter = document.querySelector('#' + state[key]['slider'].parentElement.dataset.minid);
                } else if (key.endsWith('_max')) {
                    InputFilter = document.querySelector('#' + state[key]['slider'].parentElement.dataset.maxid);
                }

                if (InputFilter != null) {
                    InputFilter.value = '';
                }

            } else {
                filtersForm.querySelector('#' + key).checked = false;
                InputFilter = document.querySelector('#' + key);
            }

            if (typeof (smartFilter) != 'undefined' && smartFilter != null && InputFilter != null) {
                smartFilter.reload(InputFilter);
            }


            delete state[key];
            renderState(key, true);
            return true;
        }

    }

    const renderState = (key, del) => {

        const selectionNode = filtersForm.querySelector('.m-catalog-filters__selection-body');

        if (del) {
            selectionNode.querySelector('[data-key=' + key + ']') && selectionNode.querySelector('[data-key=' + key + ']').remove();
            if (selectionNode.children.length < 2) {
                selectionNode.parentElement.classList.remove('m-catalog-filters__selection_show');
                document.querySelector('.js-mobile-filters')
                && document.querySelector('.js-mobile-filters').classList.remove('m-catalog-controls__filters_checked');
                document.querySelector('.m-catalog-filters-mobile-counter').innerText = '';
            }
            return true;
        }

        let btn = selectionNode.querySelector('[data-key=' + key + ']');

        if (!btn) {
            btn = document.createElement('button');
            btn.setAttribute('type', 'button');
            btn.setAttribute('data-key', key);
            selectionNode.append(btn);

            btn.addEventListener('click', (e) => {
                e.preventDefault();
                updateState(key, 'delete');
            })
        }

        btn.innerText = state[key]['value'];

        if (selectionNode.children.length > 1) {
            selectionNode.parentElement.classList.add('m-catalog-filters__selection_show');
            document.querySelector('.js-mobile-filters')
            && document.querySelector('.js-mobile-filters').classList.add('m-catalog-controls__filters_checked');
            document.querySelector('.m-catalog-filters-mobile-counter').innerText = String(selectionNode.children.length - 1);
        }
    }

    for (const resetBtn of document.querySelectorAll('.js-filters-reset')) {
        resetBtn.addEventListener('click', (e) => {
            e.preventDefault();
            filtersForm.reset();
        })
    }

    filtersForm.addEventListener('reset', () => {

        Object.keys(state).map((key) => {
            updateState(key, 'delete');
        })

        for (const slider of filtersForm.querySelectorAll('.input-range__slider')) {
            slider.noUiSlider.reset();
        }

        filtersForm.querySelector('.m-catalog-filters__selection').classList.remove('m-catalog-filters__selection_show');
    })

    // mobile
    for (const btnMobile of document.querySelectorAll('.js-mobile-filters')) {
        btnMobile.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.m-catalog-layout__sidebar').classList.add('modal-show');
            document.querySelector('.m-catalog-layout__overflow').classList.add('m-catalog-layout__overflow_show');
        })
    }

    for (const filtersCloseBtn of document.querySelectorAll('.js-mobile-filters-close')) {
        filtersCloseBtn.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.modal-show').classList.remove('modal-show');
            document.querySelector('.m-catalog-layout__overflow').classList.remove('m-catalog-layout__overflow_show');
        })
    }

}

const bindShowSortModal = () => {
    for (const sortBtn of document.querySelectorAll('.js-mobile-sort')) {
        sortBtn.addEventListener('click', (e) => {
            e.preventDefault();

            document.querySelector('.m-catalog-sort').classList.add('modal-show');
            document.querySelector('.m-catalog-layout__overflow').classList.add('m-catalog-layout__overflow_show');
        })
    }

    for (const sortLink of document.querySelectorAll('.m-catalog-sort__link')) {
        sortLink.addEventListener('click', closeCatModal)
    }
}

const closeCatModal = () => {
    document.querySelector('.modal-show') && document.querySelector('.modal-show').classList.remove('modal-show');
    document.querySelector('.m-catalog-layout__overflow') && document.querySelector('.m-catalog-layout__overflow').classList.remove('m-catalog-layout__overflow_show');
}

const bindOverflowClick = () => {
    const ovf = document.querySelector('.m-catalog-layout__overflow');
    if (!ovf) {
        return false;
    }
    ovf.addEventListener('click', closeCatModal)
}

const bindWarehouseMap = (node) => {
    if (!node || !node.dataset['mapCenter']) {
        return false;
    }

    let storeMap;

    const center = JSON.parse(node.dataset['mapCenter']);

    ymaps.ready(function () {
        storeMap = new ymaps.Map(node, {
            center: center,
            zoom: 16,
        }, {
            searchControlProvider: 'yandex#search'
        });
        storeMap.behaviors.disable('scrollZoom');

        const balloonLayout = ymaps.templateLayoutFactory.createClass(`
                    <div class="contactsMapBalloon">` +
            '<div class="contactsMapBalloon__close js-balloon-close">&#10006;</div>' +
            '$[[options.contentLayout observeSize minWidth=235 maxWidth=235 maxHeight=350]]' +
            `</div>
                `, {
            build: function () {
                this.constructor.superclass.build.call(this);
                const close = document.querySelector('.js-balloon-close');
                if (close) {
                    close.addEventListener('click', (e) => {
                        this.events.fire('userclose');
                    });
                }
            },
            clear: function () {
                this.constructor.superclass.clear.call(this);
            }
        });
        const balloonContentLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="contactsMapBalloon__name">$[properties.balloonHeader]</div>' +
            '$[properties.balloonContent]'
        );

        let placemark = new ymaps.Placemark(center, {
            hintContent: node.dataset['name'] || '',
            balloonHeader: node.dataset['name'] || '',
            balloonContent: '<div class="contactsMapBalloon__address">' + node.dataset['address'] + '</div>' +
                '<a class="m-btn m-btn_ghost" ' +
                'href="https://yandex.ru/maps/?ll=' + center[1] + ',' + center[0] + '&rtext=~' + center[0] + ',' + center[1] + '&rtt=auto&z=16"\n' +
                'target="_blank"><span>' + node.dataset['btnText'] + '</span></a>',
        }, {
            balloonShadow: false,
            balloonLayout: balloonLayout,
            balloonContentLayout: balloonContentLayout,
            balloonPanelMaxMapArea: 0,

            iconLayout: 'default#image',
            iconImageHref: '/contacts/images/map-point.svg',
            iconImageSize: [55, 74],
            iconImageOffset: [-28, -60],
        });
        storeMap.geoObjects.add(placemark);

    });

}

const createMsBreadcrumbs = (node) => {
    if (!node) {
        return false;
    }

    const items = [...node.querySelectorAll('li')];

    if (items.length < 4) {
        node.classList.remove('ms-breadcrumbs_loading');
        return false;
    }

    const popup = document.createElement('div');
    popup.classList.add('ms-breadcrumbs__popup');
    const popupClose = document.createElement('button');
    popupClose.setAttribute('type', 'button');
    popupClose.classList.add('ms-breadcrumbs__popup-close');
    popup.append(popupClose);

    let pseudoLI = null;
    const constructHTML = (itemsArr, root) => {
        root.innerHTML = '';
        items.map((item, index) => {
            if (index < 2 || index === itemsArr.length - 1) {
                root.append(item);

                const link = item.querySelector('a, span').cloneNode(true);
                link.classList.add('ms-breadcrumbs__popup-mobile-link');

                popup.append(link);

                return true;
            }

            if (!pseudoLI) {
                pseudoLI = document.createElement('li');
                pseudoLI.classList.add('ms-breadcrumbs__additional-li');
                const btn = document.createElement('button');
                btn.setAttribute('type', 'button');
                btn.innerHTML = '...';


                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    pseudoLI.classList.toggle('ms-breadcrumbs__additional-li_opened');
                })

                pseudoLI.append(btn);
                pseudoLI.append(popup);
                root.append(pseudoLI);
            }

            popup.innerHTML += item.innerHTML;
        })
    }

    constructHTML(items, node.querySelector('ul'));

    const closeBtnNode = node.querySelector('.ms-breadcrumbs__popup-close');

    if (closeBtnNode) {
        closeBtnNode.addEventListener('click', () => {
            const openedModal = node.querySelector('.ms-breadcrumbs__additional-li_opened');
            if (openedModal) {
                openedModal.classList.remove('ms-breadcrumbs__additional-li_opened');
            }
        })
    }



    node.classList.remove('ms-breadcrumbs_loading');
}

const bindReviewsRatingInput = (node) => {
    if (!node) {
        return false;
    }

    const input = node.querySelector('input');

    if (!input) {
        return false;
    }

    const buttons = [...node.querySelectorAll('button')];

    buttons.map((button) => {
        button.addEventListener('mouseover', () => {
            const elementValue = button.getAttribute('data-value');
            if (elementValue) {
                node.setAttribute('data-current', elementValue);
            }
        })
        button.addEventListener('mouseout', () => {
            node.setAttribute('data-current', input.value);
        })
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const elementValue = button.getAttribute('data-value');
            if (elementValue) {
                node.setAttribute('data-current', elementValue);
                input.value = elementValue;
            }
        })
    })
}

const watchForCatalogTableResize = () => {
    const catalogTable = document.querySelector('.az-table-catalog');

    if (!catalogTable) {
        return false;
    }

    if (window.matchMedia('(max-width: 1300px)').matches) {
        const url = new URL(window.location.href);
        url.searchParams.set('VIEW', 'list');
        window.location.replace(url);
    }

    window.addEventListener('resize', () => {
        if (window.matchMedia('(max-width: 1300px)').matches) {
            const url = new URL(window.location.href);
            url.searchParams.set('VIEW', 'list');
            window.location.replace(url);
        }
    })
}


window.addEventListener('load', async function () { // 'DOMContentLoaded'

    for (const slider of document.querySelectorAll('.m-front-slider .swiper')) {
        bindFrontSlider(slider)
    }

    for (const sliderCat of document.querySelectorAll('.m-catalog-sections_upd .swiper')) {
        bindCatalogSlider(sliderCat)
    }

    for (const catalogFilters of document.querySelectorAll('.js-catalog-filters')) {
        bindCatalogFilters(catalogFilters)
    }

    bindShowSortModal();

    bindOverflowClick();

    for (const whMap of document.querySelectorAll('.js-store-map')) {
        bindWarehouseMap(whMap)
    }

    for (const graphicRatingInput of document.querySelectorAll('.js-reviews-rating')) {
        bindReviewsRatingInput(graphicRatingInput)
    }

    for (const breadcrumbs of document.querySelectorAll('.ms-breadcrumbs')) {
        createMsBreadcrumbs(breadcrumbs)
    }

    // await buildEducationPrograms(document.getElementById('educationPrograms'));

    watchForCatalogTableResize();
    Fancybox.bind('[data-fancybox="video"]');
    /* for (const video of document.querySelectorAll('[data-fancybox="video"]')) {
        Fancybox.bind(video);
    } */
});

